import React, { useEffect, useMemo } from 'react'

import { useLocation } from 'react-router-dom'

import { Section } from '../components/ContainerSection'
import ProfileView from '../components/profile/ProfileView'
import { useUser } from '../context'
import { AnyProfile, NewUser, ProfileRole } from '../types'

const INITIAL_STATE = {
  uid: '',
  name: '',
  lastname: '',
  phone: '',
  birthDate: '',
  email: '',
  genre: '',
  title: '',
  activities: [],
  experienceType: [],
  image: '',
  professors: [],
  dropboxLink: '',
  password: '',
  confirmPassword: '',
  confirmEmail: '',
  role: null,
}

const NewUserPage = () => {
  const location = useLocation()
  const { setOnEditionMode, userRole } = useUser()
  const queryParams = new URLSearchParams(location.search)
  const userParam = queryParams.get('user')

  //   const [newProfile, setNewProfile] = useState<AnyProfile>(INITIAL_STATE)
  const initialProfile: AnyProfile = useMemo(() => {
    if (!userParam) {
      return INITIAL_STATE
    } else {
      switch (userParam) {
        case 'student':
          return {
            ...INITIAL_STATE,
            role: userParam as ProfileRole,
            hasActiveBonus: false,
            activeBonus: null,
            currentAmountOfClasses: 0,
            currentAttendance: 0,
          } as NewUser
        default:
          return { ...INITIAL_STATE, role: userParam as ProfileRole }
      }
    }
  }, [userParam])

  useEffect(() => {
    setOnEditionMode(true)
  }, [])

  return (
    <Section
      title="Nuevo usuario"
      childrenClass="content-childrens"
      style={{
        overflowY: 'scroll',
        maxHeight: `calc(100vh - ${userRole === 'professor' ? '250px' : '290px'})`,
      }}
    >
      <ProfileView initialProfile={initialProfile} isNewUser={true} />
    </Section>
  )
}

export default NewUserPage
